import React, { useState } from "react";
import axios from "axios";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import { message } from "antd";
import { useNavigate } from "react-router-dom";
import SubAdminHeader from "../components/SubAdminHeader";
import Footer from "../../../components/superAdmin/footer/Footer";

function ChangePassword() {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const token = localStorage.getItem("jff_token");
    if (!token) {
        navigate("/subadmin/login");
        return;
    }

    if (newPassword !== confirmNewPassword) {
      message.error("New Password and Confirm New Password do not match");
      return;
    }

    axios
      .post(
        `${process.env.REACT_APP_API_END_POINT}/change-password`,
        {
          old_password: oldPassword,
          new_password: newPassword,
          id: localStorage.getItem("user_id"),
        },
        {
          headers: {
            token: token,
          },
        }
      )
      .then((res) => {
        message.success("Password Changed Successfully");
        setOldPassword("");
        setNewPassword("");
        setConfirmNewPassword("");
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          localStorage.clear();
          navigate("/subadmin/login");
        } else if (err.response?.status === 404) {
          message.warning("Please Enter Correct Old Password");
        } else {
          message.error("Something went wrong. Please try again.");
        }
      });
  };

  return (
    <>
      <SubAdminHeader />
      <div className="container">
        <h3 className="d-flex justify-content-center mt-3 text-decoration-underline">
          Change Password
        </h3>
        <Form className="exhibitorlogin" onSubmit={handleSubmit}>
          <Form.Group
            as={Row}
            className="mb-3"
            controlId="oldPassword"
          >
            <Form.Label column sm="4">
              Old Password <font color="#FF0000">*</font>
            </Form.Label>
            <Col sm="8">
              <Form.Control
                placeholder="Old Password"
                required
                autoComplete="off"
                value={oldPassword}
                onChange={(e) => setOldPassword(e.target.value)}
              />
            </Col>
          </Form.Group>
          <Form.Group
            as={Row}
            className="mb-3"
            controlId="newPassword"
          >
            <Form.Label column sm="4">
              New Password <font color="#FF0000">*</font>
            </Form.Label>
            <Col sm="8">
              <Form.Control
                placeholder="New Password"
                required
                autoComplete="off"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />
            </Col>
          </Form.Group>
          <Form.Group
            as={Row}
            className="mb-3"
            controlId="confirmNewPassword"
          >
            <Form.Label column sm="4" className="fs-6">
              Confirm New Password <font color="#FF0000">*</font>
            </Form.Label>
            <Col sm="8">
              <Form.Control
                placeholder="Confirm New Password"
                required
                autoComplete="off"
                value={confirmNewPassword}
                onChange={(e) => setConfirmNewPassword(e.target.value)}
              />
            </Col>
          </Form.Group>

          <div className="my-4 d-flex justify-content-center">
            <Button type="submit" className="btn-block">
              Update
            </Button>
          </div>
        </Form>
      </div>
      <Footer />
    </>
  );
}

export default ChangePassword;
